export default "__VITE_ASSET__BJrrwkuW__"